export function getScrollbarWidth() {
    const outer = document.createElement('div');
    const style = outer.style as CSSStyleDeclaration & { msOverflowStyle: string };
    style.visibility = 'hidden';
    style.overflow = 'scroll';
    style.msOverflowStyle = 'scrollbar';

    if (!document.body) {
        return 0;
    }

    document.body.appendChild(outer);

    const inner = document.createElement('div');
    outer.appendChild(inner);

    const scrollbarWidth = outer.offsetWidth - inner.offsetWidth;
    outer.parentNode?.removeChild(outer);

    return scrollbarWidth;
}
